import { useUserIdentity } from '@src/stores-v2/StoreContext';
import { useFlagsCombination } from '@src/utility/useFlagsCombination';
import { observer } from 'mobx-react-lite';
import { Navigate, useSearchParams } from 'react-router-dom';

import { VideoCreator } from '../VideoCreator';

/**
 * Controls which page is shown at the root route (`/`).
 *
 * When `homeEnableDefaultLanding` is enabled (true):
 *   - Redirects to `/home` so the homepage is the default landing page.
 *
 * When disabled (false):
 *   - Renders the Creator Studio (VideoCreator) as the default landing page.
 */
export const DefaultLandingRoute = observer(() => {
  const userIdentity = useUserIdentity();
  const { homeEnableDefaultLanding } = useFlagsCombination(
    userIdentity.currentRole,
  );
  const [searchParams] = useSearchParams();

  if (homeEnableDefaultLanding) {
    return <Navigate to={`/home?${searchParams.toString()}`} replace />;
  }

  return <VideoCreator />;
});
